global.$ = require("../../node_modules/jquery/dist/jquery");
global.jQuery = global.$;

require('../../node_modules/bootstrap/js/src/scrollspy');
$('body').scrollspy({ target: '#glossary-list-nav' });
